import React from "react";
import {
  Box,
  Typography,
  IconButton,
  Divider,
  Tooltip,
  makeStyles,
  Zoom,
} from "@material-ui/core";
import GitHubIcon from "@material-ui/icons/GitHub";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import TwitterIcon from "@material-ui/icons/Twitter";
import YouTubeIcon from "@material-ui/icons/YouTube";
import theme from "../../theme/theme";
import * as styles from "../../theme/commonStyles";
import MailIcon from "@material-ui/icons/Mail";
import PhIcon from "@material-ui/icons/Phone";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";

const ContactPage = () => {
  const useStyles = makeStyles({
    mainDiv: {
      backgroundColor: "rgba(0, 0, 0, 0.92)",
      position: "relative",
      bottom: "0",
      marginTop: "5rem",
    },
    columnDiv: {
      ...styles.columnDiv,
    },
    rowDiv: {
      ...styles.rowDiv,
    },
    headerText: {
      ...styles.headerText,
    },
    contactText: {
      color: "#eeeeee",
      margin: "0.5rem",
      textShadow: "0.1rem 0.1rem #4f4f4f",
    },
    divider: {
      ...styles.divider,
    },
    contactDivider: {
      backgroundColor: "#eeeeee",
    },
    emailText: {
      color: "#eeeeee",
      fontSize: "1.5rem",
      fontWeight: 500,
    },
    link: {
      fontSize: "1.5rem",
      fontWeight: 500,
    },
    icon: {
      color: "#eeeeee",
      margin: "0.1rem",
      [theme.breakpoints.down("sm")]: {
        margin: "0.1.5rem",
      },
    },
    github: {
      fontSize: "1.5rem",
    },
    linkedIn: {
      fontSize: "1.5rem",
    },
    twitter: {
      fontSize: "1.5rem",
    },
    youtube: {
      fontSize: "1.5rem",
    },
    mailicon: {
      fontSize: "1.5rem",
    },
  });
  const classes = useStyles();

  const icons = (
    <Box className={classes.rowDiv} id="Contact">
      <Tooltip title="Phone" arrow TransitionComponent={Zoom}>
        <IconButton
          className={classes.icon}
          aria-label="Phone Link"
          onClick={() => window.open("tel:+1201-218-1313")}
        >
          <PhIcon className={classes.linkedIn} />
        </IconButton>
      </Tooltip>
      <Tooltip title="WhatsApp" arrow TransitionComponent={Zoom}>
        <IconButton
          className={classes.icon}
          aria-label="WhatsApp Link"
          onClick={() => window.open("https://wa.me/12012181313")}
        >
          <WhatsAppIcon className={classes.linkedIn} />
        </IconButton>
      </Tooltip>
      <Tooltip title="Email" arrow TransitionComponent={Zoom}>
        <IconButton
          className={classes.icon}
          aria-label="Email Link"
          onClick={() => window.open("mailto:kishor4u@gmail.com")}
        >
          <MailIcon className={classes.linkedIn} />
        </IconButton>
      </Tooltip>
      <Tooltip title="LinkedIn" arrow TransitionComponent={Zoom}>
        <IconButton
          className={classes.icon}
          aria-label="LinkedIn Link"
          onClick={() =>
            window.open(
              "https://www.linkedin.com/in/kishore-shiraguppi-a5a204b/"
            )
          }
        >
          <LinkedInIcon className={classes.linkedIn} />
        </IconButton>
      </Tooltip>
      <Tooltip title="GitHub" arrow TransitionComponent={Zoom}>
        <IconButton
          className={classes.icon}
          aria-label="GitHub link"
          onClick={() => window.open("https://github.com/kishoregs/")}
        >
          <GitHubIcon className={classes.github} />
        </IconButton>
      </Tooltip>
      {/* <Tooltip title="CodePen" arrow TransitionComponent={Zoom}>
        <IconButton
          className={classes.icon}
          aria-label="CodePen link"
          onClick={() => window.open("https://codepen.io/kishoreshiraguppi")}
        >
          <span
            className="iconify"
            data-icon="ant-design:codepen-outlined"
            data-inline="false"
            style={{ fontSize: "2.8rem" }}
          />
        </IconButton>
      </Tooltip> */}
      <Tooltip title="Twitter" arrow TransitionComponent={Zoom}>
        <IconButton
          className={classes.icon}
          aria-label="Twitter link"
          onClick={() => window.open("https://twitter.com/kishoregs4u")}
        >
          <TwitterIcon className={classes.twitter} />
        </IconButton>
      </Tooltip>
      <Tooltip title="YouTube" arrow TransitionComponent={Zoom}>
        <IconButton
          className={classes.icon}
          aria-label="YouTube link"
          onClick={() => window.open("https://www.youtube.com/kishoregs4u/")}
        >
          <YouTubeIcon className={classes.youtube} />
        </IconButton>
      </Tooltip>
    </Box>
  );

  return (
    <Box className={`${classes.columnDiv} ${classes.mainDiv}`}>
      <Typography className={`${classes.headerText} ${classes.contactText}`}>
        Contact Me
      </Typography>
      <Divider
        classes={{ root: `${classes.divider} ${classes.contactDivider}` }}
      />

      {icons}
    </Box>
  );
};

export default ContactPage;
